<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Consignment List</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="mb-3">Filter by</h5>
                        <a-form :form="form"  @submit="searchHandel">
                            <div class="row">
                                <div class="mb-4 col-md-3">
                                    <a-form-item>
                                        <a-input size="large"
                                            v-decorator="['unique_id', { rules: [{ required: false }] }]"
                                            placeholder="Search By Consignment ID"
                                        />
                                    </a-form-item>
                                </div>
                                <div class="mb-4 col-md-3">
                                    <a-form-item>
                                        <a-select size="large"
                                            show-search
                                            :filter-option="filterOption"
                                            v-decorator="['hub_id', { rules: [{ required: false }] }]"
                                            placeholder="Search by hub">
                                            <template v-for="hub in hubs" >
                                                <a-select-option :key="hub.id" :value="hub.id">
                                                    {{hub.name}}
                                                </a-select-option>
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </div>
                                <!-- <div class="mb-4 col-md-3">
                                    <a-form-item>
                                        <a-select size="large"
                                            v-decorator="[ 'status',
                                                { rules: [{ required: false}] },
                                            ]"
                                            placeholder="Search by status"
                                        >
                                            <a-select-option value="1">
                                                Active
                                            </a-select-option>
                                            <a-select-option value="0">
                                                Inactive
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </div> -->

                                <div class="col-md-12 text-right">
                                        <a-button type="primary" class="btn btn-secondary rounded font-md mr-2" size="large" @click="resetFilter">
                                            Reset
                                        </a-button>
                                        <a-button type="primary" class="btn btn-xs rounded font-md" size="large" html-type="submit">
                                            Filter
                                        </a-button>
                                </div> 
                            </div>
                            </a-form>
                    </div>
                </div> <!-- card end// -->
            </div>
            <div class="col-md-12">
                <a-card >
                    <a-table
                        :columns="columns"
                        :data-source="consignments"
                        :pagination="{ 
                            current: currentPage,
                            total: pageCount * 10,
                            onChange: (page) => paginate(page),
                         }"
                        :scroll="{x: 'calc(600px + 50%)', y: 900 }"
                        rowKey="id"
                    > <!-- x: 'calc(600px + 50%)', -->
                        <span slot="status" slot-scope="text, record">
                            {{record.status ? 'Active' : 'Inactive'}}
                        </span>

                        <span slot="action" slot-scope="text, record">
                            <template v-if="record.status === 0">
                                <a-button type="primary" size="small" @click="startDelevary(record)" :disabled="checkisdisable(record)"
                                    style="background: orange; border-color: orange;" class="px-5">
                                    Start
                                </a-button>   
                            </template>
                            <template v-if="record.status === 1">
                                <span>Delivery Processing</span>
                            </template>
                            <template v-if="record.status === 2">
                                <template v-if="canView()">
                                    <router-link :to="'/manage-reconsignment/'+record.id" type="primary"
                                    class="btn btn-xs" size="small">
                                        Reconciliation
                                    </router-link>
                                </template>
                            </template>

                            <template v-if="record.status === 3">
                                <span>Reconciliction Completed</span>
                            </template>
                        </span>

                        <span slot="total_collectable" slot-scope="text, record">
                            {{calTotalCollectable(record)}}
                        </span>
                        <span slot="total_collection" slot-scope="text, record">
                            {{totalcalTotalCollected(record)}}
                        </span>
                        <span slot="total_task" slot-scope="text, record">
                            {{record.tasks.length}}
                        </span>
                    </a-table>
                </a-card>
            </div>
        </div>
    </div>
</template>


<script>
    import { CONSIGNMENT_LIST, HUB_LIST, CONSIGNMENT_STATUS_UPDATE } from "../../../script/api";
    import { getData, postData } from "../../../script/api-service";
    import {buildSearchQuery, alertPop, checkUserPermission} from "../../../script/helper";
    import { totalCollectable, totalCollected } from './helper';
    import moment from "moment";

    const columns = [
        {
            title: 'Consignment ID',
            width: 150,
            dataIndex: 'unique_id',
        },
        {
            title: 'Rider Name',
            width: 130,
            dataIndex: 'rider.name',
        },
        {
            title: 'Rider Mobile',
            width: 130,
            dataIndex: 'rider.mobile',
        },
        {
            title: 'Total Tasks ',
            width: 100,
            scopedSlots: { customRender: 'total_task' },
        },
        {
            title: 'Total Collectable ',
            width: 120,
            scopedSlots: { customRender: 'total_collectable' },
        },
        {
            title: 'Total Collected',
            width: 120,
            scopedSlots: { customRender: 'total_collection' },
        },
        {
            title: 'Hub',
            width: 140,
            dataIndex: 'hub.name',
        },
        {
            title: 'Date',
            width: 100,
            dataIndex: 'date',
        },
        {
            title: 'Action',
            key: 'action',
            width: 150,
            // fixed: "right",
            scopedSlots: { customRender: 'action' },
        }
    ];

    export default {
        data() {
            return {
                columns,
                consignments: [],
                form: this.$form.createForm(this, { name: 'searchArea' }),
                search: null,
                hubs: [],
                currentPage: 1, 
                pageCount: 0
            };
        },
        watch: {
            search: function (newVal, oldVal) {
                if (newVal || (!newVal && oldVal)) {
                    this.getConsignmentList(newVal);
                }
            },
        },
        methods: {
            canView() {
                return checkUserPermission('view_reconciliation');
            },
            checkisdisable(consignment) {
                if (moment(consignment.date, "YYYY-MM-DD").isSameOrAfter(moment())) return true;
                else return false;
            },
            calTotalCollectable(order) {
                return totalCollectable(order.tasks);
            },
            totalcalTotalCollected(order) {
                return totalCollected(order.tasks);
            },
            async getConsignmentList(query) {
                let url = CONSIGNMENT_LIST + '?';
                if (query) url = url + query; 
                if (this.currentPage) url = url + `&page=${this.currentPage}`;
                
                let res = await getData(url);

                if (res) {
                    let masterData = res.data?.data;
                    this.consignments = masterData.data || [];
                    this.pageCount = masterData.paginator.total_pages;
                }
            },
            async getHubs() {
                let res = await getData(HUB_LIST);

                if (res) {
                    let masterData = res.data?.data;
                    this.hubs = masterData || [];
                }
            },
            searchHandel(e) {
                e.preventDefault();
                this.form.validateFields( async(err, values) => {
                    if (!err) {
                        this.search = buildSearchQuery(values);
                    }
                })
            },
            resetFilter() {
                this.form.resetFields();
                this.search = '';
            },
            paginate(page) {
                this.currentPage = page;
                this.getConsignmentList(this.search);
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            async startDelevary(data) {
                let res = await postData(CONSIGNMENT_STATUS_UPDATE, {
                    consignment_id: data.id,
                    status: 1
                });

                if (res) {
                    alertPop('success', "Process completed Successfully");
                    this.getConsignmentList(this.search);
                } else {
                    alertPop('error', "Something went wrong. Please try again later")
                }
            }
        },
        mounted() {
            this.getConsignmentList();
            this.getHubs();
            
            // if (!checkUserPermission('view_reconciliation')) {
            //     this.columns.pop();
            // }
        },
    };
</script>